
export const COMMISSION_CALCULATION = [
    'included_in_price',
    'on_top_of_price',
    'refund',
    'chargeback',
    'decline',
    'fraud',
    'payout_included_in_price',
    'payout_on_top_of_price'
];

